//--general
require('default-passive-events');

import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import 'bootstrap';
import { Tooltip } from 'bootstrap';
import 'slick-carousel';
import sliders from './parts/sliders.js';
import 'selectize';

require('jquery-ui-bundle');

[...document.querySelectorAll('[data-bs-toggle="tooltip"]')]
  .forEach(el => new Tooltip(el));

(function ($) {

    //-- delay function for resizing
    var delay = (function() {
        var timer = 0;
        return function(callback, ms) {
            clearTimeout(timer);
            timer = setTimeout(callback, ms);
        }
    })();
    
    $(window).on('load', function() { 
            sliders.sliders();
            sliders.slider4();    
    });    

    $(document).ready(function(){

        $( "#slider-range" ).slider({
            range: true,
            min: 0,
            max: 15000,
            values: [ 0, 0 ],
            slide: function( event, ui ) {
              $( "#amount" ).val( ui.values[ 0 ] + "-" + ui.values[ 1 ] + " " );

              $( "#amount-text" ).html(  "<div>" + ui.values[ 0 ] + "</div><div>" + ui.values[ 1 ] + "</div>");
            }
          });
          $( "#amount" ).val( $( "#slider-range" ).slider( "values", 0 ) + " - " + $( "#slider-range" ).slider( "values", 1 ) + " " );

          $( "#amount-text" ).html( "<div>" + $( "#slider-range" ).slider( "values", 0 ) + "</div><div>" + $( "#slider-range" ).slider( "values", 1 ) + "</div>" );


        $('select.select2').selectize();

        function setIconTable() {
            let tableWrapper = $(".table-wrapper");
            let table = $(".table-wrapper table");

            if (table.width() > tableWrapper.width()) {
                tableWrapper.addClass("scroll")
            } else {
                tableWrapper.removeClass("scroll")
            }
        }

        setIconTable();

        $(window).resize(function(){
            setIconTable();
        });

        var COUNTRIES = [];
        
        $('.langs-wrapper .langs option').each(function() {
            COUNTRIES.push({
                'code': $(this).data('flag'),
                'name': $(this).html(),
                'value': $(this).val()
            });
        });

        $('select.langs').selectize({
            maxItems: 1,
            options: COUNTRIES,
            labelField: 'name',
            valueField: 'value',
            searchField: ['name', 'code'],
            preload: true,
            render: {
                item: function(item, escape) {
                    console.log(item);
                    return ("<div><span class='flag-icon flag-icon-" + escape(item.code) + "'></span><span class='txt'>" + escape(item.name) + "</span></div>");
                },
                option: function(item, escape) {
                    console.log(item);
                    return ("<div><span class='flag-icon flag-icon-" + escape(item.code) + "'></span><span class='txt'>" + escape(item.name) + "</span></div>");
                }
            }            
        });

       $(".add-artist-select").selectize({
        maxItems: 10
       });

       $("#nav-btn").click(function(){
           $(".navigation").toggleClass("opened");
       });

       $("#close-nav").click(function(){
        $(".navigation").toggleClass("opened");
        });

    });

    


    $(window).on({
        load:function(){

        },
        resize:function(){

        },
        scroll:function(){

       }
    });

}(jQuery));


